var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { background, border, display, space } from 'styled-system';
import styled from '@emotion/styled';
import { cursor } from '../../theme/system-utilities';
export var SPINNER_SIZE = 24;
export var ButtonBase = styled.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"])), space, display, background, border, cursor);
ButtonBase.defaultProps = {
    display: 'inline-flex',
    m: 0,
    p: 0,
    background: 'none',
    border: 'none',
    cursor: 'pointer',
};
var templateObject_1;
